import { TimeFilter } from '../enums/time-fileter.enum';

export const timeFilters = [
  TimeFilter.LAST_24_HOURS,
  TimeFilter.LAST_7_DAYS,
  TimeFilter.LAST_30_DAYS,
  TimeFilter.LAST_12_MONTHS,
  TimeFilter.ALL_TIME,
];
